import Slider, {SliderComponent} from "./slider"

interface ProductSliderComponent {
  init(): void;
  scrollMainTo(index: number): void;
  scrollThumbsTo(index: number): void;
  main: SliderComponent | null;
  thumbs: SliderComponent | null;
  mainIndex: number;
  $refs?: {
    mainWrapper: HTMLElement;
    thumbsWrapper: HTMLElement;
  };
  $el?: HTMLElement;
}

export default {
  name: 'productSlider',
  component(): ProductSliderComponent {
    return {
      main: null,
      thumbs: null,
      mainIndex: 0,
      init() {
        this.main = Slider.component();
        this.thumbs = Slider.component();

        if (!this.main || !this.$refs || !this.thumbs) return;
        
        this.main.init(this.$refs.mainWrapper, {}, false);
        this.thumbs.init(this.$refs.thumbsWrapper, {}, true);

        // Synchronisation miniatures → principal
        this.$refs.thumbsWrapper.addEventListener('click', (e) => {
          const target = e.target as HTMLElement;
          const slide = target.closest('.embla__slide') as HTMLElement;
          if (slide) {
            const index = parseInt(slide.dataset.index || '0');
            this.scrollMainTo(index);
          }
        });

        // Synchronisation principal → miniatures
        if (this.main.embla) {
          this.main.embla.on('select', () => {
            const selectedIndex = this.main.embla.selectedScrollSnap();
            this.scrollThumbsTo(selectedIndex);
          });
        }

        this.$el.addEventListener('spanish-image-updated', (e: CustomEvent) => {
          if (this.main && this.thumbs) {
            this.main.embla?.reInit();
            this.thumbs.embla?.reInit();
          }
        });
      },
      scrollMainTo(index: number) {
        if (this.main) {
          this.main.scrollTo(index);
        }
      },
      scrollThumbsTo(index: number) {
        if (this.thumbs) {
          this.thumbs.scrollTo(index);
        }
      },
    }
  }
}
